import { PART_OF_DAYS } from '../consts/enums';

export function getMonthStr(dateObj: DateObject | null | undefined):string {
  if (!dateObj?.month) {
    return '';
  }

  return dateObj.month.toString();
}

export function getYearStr(dateObj: DateObject | null | undefined):string {
  if (!dateObj?.year) {
    return '';
  }

  return dateObj.year.toString();
}

export const convertDataHelper = (objectData:
  { month: string, year: string,  name: string }):{[key:string]: string} => {
  const setTemplateDateISO = new Date(+objectData.year, +objectData.month, 1).toISOString();

  return {  [objectData.name]: setTemplateDateISO };
};

export const currentTimeToText = (): PART_OF_DAYS => {
  const now = new Date();
  const curHr = now.getHours();
  if (curHr < 6) {
    return PART_OF_DAYS.NIGHT;
  }
  if (curHr < 12) {
    return PART_OF_DAYS.MORNING;
  }
  if (curHr < 18) {
    return PART_OF_DAYS.AFTERNOON;
  }

  return PART_OF_DAYS.EVENING;
};

export function decimalToMinutesText(minutes: number): string {
  const sign = minutes < 0 ? '-' : '';
  const min = Math.floor(Math.abs(minutes));
  const sec = Math.floor((Math.abs(minutes) * 60) % 60);
  
  return `${sign + (min < 10 ? '0' : '') + min}:${sec < 10 ? '0' : ''}${sec}`;
}
